import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { LOCALE } from "@hermes/core-app-core";
import { LOGGER } from "@hermes/core-web-logger";

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
    private locale = inject(LOCALE);
    private logger = inject(LOGGER);

    public intercept<T, U>(
        request: HttpRequest<T>,
        next: HttpHandler,
    ): Observable<HttpEvent<U>> {
        let params = request.params;
        let headers = request.headers;
        const existingLocale = params.get("locale");

        if (existingLocale) {
            this.logger.warn(
                `Existing locale detected: ${existingLocale} on ${request.url}. It will be replaced with: ${this.locale.code}`,
            );
            params = params.delete("locale");
            headers = headers.delete("locale");
        }

        // add exception for some endpoints using POST method
        if (request.method === "POST") {
            headers = headers.set("locale", this.locale.code);
        } else {
            params = params.set("locale", this.locale.code);
        }

        const updatedRequest = request.clone({ headers, params });
        return next.handle(updatedRequest);
    }
}
